  <app-toast aria-live="polite" aria-atomic="true"></app-toast>
<nav class="navbar navbar-default navbar-static-top row" role="navigation">
  <div class="navbar-header" style="width:100%; display: flex">
      <a routerLink="">
        <img src="/assets/main_logo_130px.png" style="position: absolute; width:130px; margin:1px 15px 0px 35px;"/>
      </a>
      <a style="" class="navbar-brand" href="/" [innerHTML]="title"></a>

  </div>


  <!-- /.navbar-header -->

  <ul class="nav navbar-top-links navbar-right">

    <!-- put breadcrumbs here -->


    <!-- /.dropdown -->
  </ul>
</nav>
<div style="display: flex; flex-direction: row; flex: 1;">
  <app-navigation></app-navigation>
  <div style="padding: 10px; width: 100%;">
    <router-outlet></router-outlet>
  </div>
</div>
